import React, { Component } from 'react';

import { FilterMode } from '../constants';
import DirectoryPathFilter from '../containers/directory-path-filter';
import RefSelector from '../containers/ref-selector';

import { DirectoryFilter } from './directory.style';

type Props = {
  path?: string;
  filterMode: FilterMode;
};

export default class DirectoryHeader extends Component<Props> {
  render() {
    return (
      <DirectoryFilter>
        <RefSelector path={this.props.path} />
        <DirectoryPathFilter filterMode={this.props.filterMode} />
      </DirectoryFilter>
    );
  }
}
